import React, { createContext, useState } from 'react'
import PropTypes from 'prop-types'
import { decodeValidToken, readStoredSession } from '../lib/authToken'

const AuthContext = createContext()

export const checkTokenExpired = (token) => {
  const session = decodeValidToken(token)

  if (session.token) {
    localStorage.setItem('token', session.token)
  } else {
    localStorage.removeItem('token')
  }

  return session
}

const useToken = () => {
  const [session, setSession] = useState(readStoredSession)
  const setToken = (t) => setSession(checkTokenExpired(t))
  const checkToken = () => checkTokenExpired(localStorage.getItem('token'))
  const removeToken = () => setSession(checkTokenExpired(null))
  const { user, token } = session
  return {
    user, token, setToken, checkToken, removeToken,
  }
}

export const AuthProvider = (props) => {
  const { children } = props
  const {
    user, token, setToken, checkToken, removeToken,
  } = useToken()
  return (
    <AuthContext.Provider value={{
      user, token, setToken, checkToken, removeToken,
    }}
    >
      {children}
    </AuthContext.Provider>
  )
}
AuthProvider.propTypes = {
  children: PropTypes.node,
}
AuthProvider.defaultProps = {
  children: null,
}

export const AuthConsumer = AuthContext.Consumer

export default AuthContext
